var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 6.37497C23.9995 8.23497 22.4845 9.74997 20.6245 9.74997H15.3745C14.4445 9.74997 13.6045 9.37497 12.9895 8.75997C12.3745 8.14497 11.9995 7.30497 11.9995 6.37497C11.9995 4.51497 13.5145 2.99997 15.3745 2.99997H20.6245C21.5545 2.99997 22.3945 3.37497 23.0095 3.98997C23.6245 4.60497 23.9995 5.44497 23.9995 6.37497Z",
    fill: "#0D9DFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2455 7.54501C27.9005 7.26001 27.5105 7.03501 27.0905 6.87001C26.6555 6.70501 26.2205 7.05001 26.1305 7.50001C25.6205 10.065 23.3555 12 20.6255 12H15.3755C13.8755 12 12.4655 11.415 11.4005 10.35C10.6205 9.57001 10.0805 8.58001 9.87049 7.51501C9.78049 7.06501 9.33049 6.70501 8.89549 6.88501C7.15549 7.59001 6.00049 9.18001 6.00049 12.375V27C6.00049 31.5 8.68549 33 12.0005 33H24.0005C27.3155 33 30.0005 31.5 30.0005 27V12.375C30.0005 9.93001 29.3255 8.43001 28.2455 7.54501ZM12.0005 18.375H18.0005C18.6155 18.375 19.1255 18.885 19.1255 19.5C19.1255 20.115 18.6155 20.625 18.0005 20.625H12.0005C11.3855 20.625 10.8755 20.115 10.8755 19.5C10.8755 18.885 11.3855 18.375 12.0005 18.375ZM24.0005 26.625H12.0005C11.3855 26.625 10.8755 26.115 10.8755 25.5C10.8755 24.885 11.3855 24.375 12.0005 24.375H24.0005C24.6155 24.375 25.1255 24.885 25.1255 25.5C25.1255 26.115 24.6155 26.625 24.0005 26.625Z",
    fill: "#0D9DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e307a1af456f05abfd119d659a073def.svg";
export { ForwardRef as ReactComponent };